var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Table from './Table.vue';
import { Loading } from 'element-ui';
import ServiceService from '../../api/ServiceService';
import AccountService from '../../api/AccountService';
import _ from 'lodash';
import { EServiceStatus } from '../../enum/EStatus';
import PointRecord from './PointRecord.vue';
import GlobalVue from '../../globalVue';
import MyRightDialog from './components/MyRightDialog.vue';
import MyExchangeDialog from './components/MyExchangeDialog.vue';
import Company from '../Company.vue';
import GoodList from '../good/List.vue';
import LicenseList from '../licenseManage/LicenseList.vue';
import moment from 'moment';
import { copy } from '../../helper/clipboard';
var Service = (function (_super) {
    __extends(Service, _super);
    function Service() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.status = EServiceStatus.NoOpen.toString();
        _this.prevStatus = EServiceStatus.NoOpen.toString();
        _this.serviceStatus = EServiceStatus;
        _this.listData = [];
        _this.total = 0;
        _this.noticeData = {};
        _this.statusFromNotice = null;
        _this.service_status = null;
        _this.accountInfo = {};
        _this.taskList = [];
        _this.currentTask = {};
        _this.activityList = [];
        _this.payVisible = false;
        _this.qrcode_path = '';
        _this.isQrShow = false;
        _this.isPaid = false;
        _this.timer = null;
        _this.shareVisible = false;
        _this.shareInfo = {};
        return _this;
    }
    Service.prototype.created = function () {
        this.service = ServiceService.getInstance();
        this.accountService = AccountService.getInstance();
        this.getAccountInfo();
        this.getTaskList();
        this.getActivityList();
    };
    Service.prototype.mounted = function () {
        if (this.statusFromNotice) {
            this.status = this.statusFromNotice.toString();
        }
        if (this.service_status !== null) {
            this.status = this.service_status.toString();
            this.prevStatus = this.service_status.toString();
        }
        this.getServiceList();
    };
    Service.prototype.copy = function () {
        copy(this.shareInfo.word);
    };
    Service.prototype.hideShareModal = function () {
        this.shareVisible = false;
        this.currentTask = {};
        this.shareInfo = {};
        this.getTaskList();
    };
    Service.prototype.showShareModal = function (item) {
        var _this = this;
        this.currentTask = item;
        this.shareVisible = true;
        var posterType = item.task_type === 3 ? 3 : 6;
        this.accountService
            .getShareInfo({ type: item.task_type === 3 ? 1 : 2 })
            .then(function (res) {
            var DATA = res.data.data;
            _this.shareInfo = {
                word: DATA.find(function (item) { return item.material_type === 2; }).material_data,
                miniCode: DATA.find(function (item) { return item.material_type === 1; }).material_data,
                poster: DATA.find(function (item) { return item.material_type === posterType; }).material_data,
                rule: item.rule.condition
            };
            console.log(_this.shareInfo);
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Service.prototype.downloadImg = function () {
        window.open(this.shareInfo.poster + '?response-content-type=application/octet-stream');
    };
    Service.prototype.toComplete = function (item) {
        var pageObj = {
            101: {
                component: Company,
                title: '企业信息',
            },
            102: {
                component: LicenseList,
                title: '证照管理',
            },
            103: {
                component: GoodList,
                title: '货品档案',
            },
            104: {
                component: LicenseList,
                title: '证照管理',
            },
        };
        GlobalVue.$emit('addTab', {
            component: pageObj[item.task_type].component,
            title: pageObj[item.task_type].title,
            showExist: true,
            name: pageObj[item.task_type].title
        });
    };
    Service.prototype.getActivityList = function () {
        var _this = this;
        this.accountService
            .getActivityList()
            .then(function (res) {
            var DATA = res.data ? res.data : {};
            _this.activityList = Array.isArray(DATA.data) ? DATA.data : [];
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Service.prototype.myExchange = function () {
        this.$dialog(MyExchangeDialog, {}, {
            title: '我的兑换',
            width: 720,
            height: 500,
        });
    };
    Service.prototype.myRight = function () {
        this.$dialog(MyRightDialog, {
            data: {
                supplier_point_level_name: this.accountInfo.supplier_point_level_name,
            },
        }, {
            title: '我的权益',
            width: 720,
            height: 500,
        });
    };
    Service.prototype.toPointRecord = function () {
        GlobalVue.$emit('addTab', {
            component: PointRecord,
            title: '积分明细',
            showExist: true,
            name: 'point_record',
            cprops: {},
        });
    };
    Service.prototype.toExchange = function (item) {
        var _this = this;
        this.$confirm("\u672C\u6B21\u5151\u6362\u5C06\u6D88\u8017" + item.point + "\u79EF\u5206\uFF0C\u4F18\u60E0\u5238\u6709\u6548\u671F\u81F3" + item.end_date + "\uFF0C\u786E\u5B9A\u5151\u6362\u5417", '积分兑换', {}).then(function () {
            _this.accountService
                .joinActivity({
                activity_id: item.activity_id,
            })
                .then(function (res) {
                _this.$confirm("\u60A8\u6210\u529F\u5151\u6362" + item.activity_name + "\u4F18\u60E0\u5238\u4E00\u5F20\uFF0C\u53EF\u5728\u79EF\u5206\u5151\u6362\u4E2D\u67E5\u770B", '兑换成功', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                });
                _this.getAccountInfo();
            })
                .catch(function (err) {
                _this.$message.error(err.message);
            });
        });
    };
    Service.prototype.hidePayModal = function () {
        this.payVisible = false;
        this.currentTask = {};
        this.isQrShow = false;
        this.qrcode_path = '';
        this.isPaid = false;
        if (this.timer)
            clearInterval(this.timer);
        this.getTaskList();
    };
    Service.prototype.showPayModal = function (item) {
        var _this = this;
        var task = __assign({}, item);
        if (!item.auth_start_date) {
            task.auth_start_date = moment().format('YYYY-MM-DD');
            task.auth_end_date = moment().add(1, 'years').format('YYYY-MM-DD');
        }
        this.currentTask = task;
        this.payVisible = true;
        if (item.task_progress)
            return;
        this.accountService
            .certification({ payment_type: 2 })
            .then(function (res) {
            var DATA = res.data.data;
            _this.qrcode_path = DATA.qrcode_path;
            _this.isQrShow = true;
            _this.searchPayResult(DATA.order_id);
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Service.prototype.searchPayResult = function (order_id) {
        var _this = this;
        this.timer && clearInterval(this.timer);
        this.timer = setInterval(function () {
            _this.getPayFlag(order_id);
        }, 3000);
    };
    Service.prototype.getPayFlag = function (order_id) {
        var _this = this;
        var params = { order_id: order_id };
        this.service
            .getPayFlag(params)
            .then(function (res) {
            if (res.data.data.is_pay == 1) {
                clearInterval(_this.timer);
                _this.$message.success('支付成功！');
                _this.isQrShow = false;
                _this.isPaid = true;
            }
        })
            .catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    Service.prototype.sign = function (index) {
        var _this = this;
        var currentTask = this.taskList[index];
        this.accountService
            .sign()
            .then(function (res) {
            _this.$message.success("\u7B7E\u5230\u6210\u529F +" + currentTask.reward_point);
            _this.taskList[index].task_progress = 1;
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Service.prototype.getTaskList = function () {
        var _this = this;
        this.accountService
            .getTaskList()
            .then(function (res) {
            var DATA = res.data ? res.data : {};
            _this.taskList = Array.isArray(DATA.data) ? DATA.data : [];
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Service.prototype.getAccountInfo = function () {
        var _this = this;
        this.accountService
            .getAccountInfo()
            .then(function (res) {
            _this.accountInfo = res.data.data || {};
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Service.prototype.refreshTable = function (status) {
        this.status = status.toString();
        this.getServiceList();
    };
    Service.prototype.getServiceList = function () {
        var _this = this;
        var params = {
            service_type: this.status,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getServiceList(params)
            .then(function (res) {
            var data = res.data.data.data;
            _.forEach(data, function (item) {
                item.account_period = item.s_time.substr(0, 10) + " ~ " + item.e_time.substr(0, 10);
                item.pending_fee = item.pending_fee ? "\uFFE5" + item.pending_fee : '-';
                if (item.service_id == 4) {
                    item.payment_mode_name = '';
                }
            });
            _this.listData = data;
            _this.total = data.length;
            loadingInstance.close();
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    Service.prototype.statusChange = function (tab) {
        if (this.prevStatus == tab.name) {
            return;
        }
        this.listData = [];
        this.status = tab.name;
        this.prevStatus = tab.name;
        this.getServiceList();
    };
    Service.prototype.destroyed = function () {
        this.timer && clearInterval(this.timer);
    };
    Service = __decorate([
        Component({
            components: {
                listData: Table,
                PointRecord: PointRecord,
            },
        })
    ], Service);
    return Service;
}(Vue));
export default Service;
